import { Injectable } from '@angular/core'

// Service for any utilities that are required for the site
@Injectable()
export class UtilityService {
    constructor() {}

    //DATE METHODS
    //this method will return the CURRENT date and time and convert to UTC
    //e.g. 11:30am -> uct OR 2:4pm -> utc
    //NOTE: in the morning utc date is 1 day earlier than utc in the afternoon
    public getTodayUctDate(): string {
        let currentLocalDate = new Date(Date.now())
        let currentUtcDate = currentLocalDate.toISOString()
        return currentUtcDate
    }

    //SEE comments as for getTodayUctDate()
    public getTomorrowUctDate(): string {
        let tomorrow = new Date(Date.now())
        tomorrow.setDate(new Date(Date.now()).getDate() + 1)
        let tomorrowUtc = tomorrow.toISOString()
        return tomorrowUtc
    }

    public getTodayStartUctDateTime(): string {
        let currentLocalDate = new Date(Date.now())
        let currentLocalDateStart = new Date(currentLocalDate.setHours(0, 0, 0, 0))
        let currentUtcDateStart = currentLocalDateStart.toISOString()
        return currentUtcDateStart
    }

    public getTodayEndUctDateTime(): string {
        let currentLocalDate = new Date(Date.now())
        let currentLocalDateEnd = new Date(currentLocalDate.setHours(23, 59, 59, 999))
        let currentUtcDateEnd = currentLocalDateEnd.toISOString()
        return currentUtcDateEnd
    }

    public getTomorrowStartUctDateTime(): string {
        let currentLocalDate = new Date(Date.now())
        let currentLocalTomorrowDate = new Date(currentLocalDate.setDate(currentLocalDate.getDate() + 1))
        let currentLocalDateTomorrowStart = new Date(currentLocalTomorrowDate.setHours(0, 0, 0, 0))
        let tomorrowUtcStart = currentLocalDateTomorrowStart.toISOString()

        return tomorrowUtcStart
    }

    //this has unit tests
    public getDateFromUct(serverDate: string): Date {
        let lastChar = serverDate.substr(serverDate.length - 1)

        if (lastChar != 'Z') {
            serverDate = serverDate + 'Z'
        }

        //convert to local date from Utc
        let localDate = new Date(serverDate)
        return localDate
    }

    //this has unit tests
    public getTimeTextFromUct(serverDate: string): string {
        let convertedDate = this.getDateFromUct(serverDate)

        //get time component as 11:25am or 2:15pm
        let hours = convertedDate.getHours()
        let ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12 || 12

        let minutes = convertedDate.getMinutes()
        let strMinutes = minutes < 10 ? '0' + minutes : minutes

        return `${hours}:${strMinutes}${ampm}`
    }

    public getDateTextFromUctFormatted(serverDate: string): string {
        let convertedDate = this.getDateFromUct(serverDate)

        let day = ('0' + convertedDate.getDate()).slice(-2)
        let month = ('0' + (convertedDate.getMonth() + 1)).slice(-2)
        let year = convertedDate.getFullYear()

        return `${day}/${month}/${year}`
    }

    public getStartOfDay(originalDate: Date): Date {
        return new Date(originalDate.setHours(0, 0, 0, 0))
    }

    public getEndOfDay(originalDate: Date): Date {
        return new Date(originalDate.setHours(23, 59, 59, 999))
    }
    //END OF DATE METHODS

    //ARRAY Methods
    public removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
        })
    }
    //ARRAY Methods - End
}
